/** Guardia movil: exige sesion; el tenant se elige en /m/company. */
import { Navigate, useLocation } from 'react-router-dom';
import { useMobileAuth } from '@/state/MobileAuthContext';

export function RequireMobileSession({ children }: { children: React.ReactNode }) {
  const { user, isLoading, isAuthenticated } = useMobileAuth();
  const location = useLocation();

  if (isLoading) return <p className="p-5 text-sm text-text-secondary">Cargando…</p>;
  if (!isAuthenticated) return <Navigate to="/m/login" replace />;
  if (!user?.active_tenant_id && location.pathname !== '/m/company') {
    return <Navigate to="/m/company" replace />;
  }
  return <>{children}</>;
}
